export const API_ENDPOINT = process.env.NEXT_PUBLIC_API_ENDPOINT ?? ''
export const API_USERS = process.env.NEXT_PUBLIC_USERS_API ?? ''
export const API_VERIFY = process.env.NEXT_PUBLIC_VERIFY_API ?? ''
export const API_SERVICES = {
  authToken: '/auth-token/'
}

export const NO_IMAGE_URL = '/assets/images/resources/no-image-found.jpg'
